import PersonType from '@/classes/facturae/PersonType'
import ResidenceType from '@/classes/facturae/ResidenceType'
import Issuer from '@/classes/facturae/Issuer'
import Receiver from '@/classes/facturae/Receiver'
import Address from '@/classes/facturae/Address'
import Sociedad from '@/classes/facturae/Sociedad'
import RegistrationData from '@/classes/facturae/RegistrationData'
import ContactDetails from '@/classes/facturae/ContactDetails'
import AdminsitrativeCentre from '@/classes/facturae/AdminsitrativeCentre'
import AdminsitrativeCentreFACeB2B from '@/classes/facturae/AdminsitrativeCentreFACeB2B'
import FACeB2BIdentificatives from '@/classes/facturae/FACeB2BIdentificatives'
import TaxWithHeld from '@/classes/facturae/TaxWithHeld'
import InvoiceLine from '@/classes/facturae/InvoiceLine'
import Descuento from '@/classes/facturae/Descuento'
import Tax from '@/classes/facturae/Tax'
import PaymentMethod from '@/classes/facturae/PaymentMethod'
import FacturaeData from '@/classes/facturae/FacturaeData'

import convertFileToBase64 from '@/services/functions/convertFileToBase64'
import getNullableNumber from '@/services/functions/getNullableNumber'

async function getPayloadFacturae (form, { includeFiles = true, overrideTemplate = null } = {}) {
  const payload = new FacturaeData()
  payload.serieFactura = form.serieFactura || null
  payload.numFactura = form.numFactura || null
  payload.dateEmision = form.dateEmision || null
  payload.albaran = form.albaran || null
  payload.pedido = form.pedido || null
  payload.tipoImpuestoFactura = form.tipoImpuestoFactura || null
  payload.observaciones = form.observaciones || null
  payload.numExpediente = form.numExpediente || null
  payload.dateExpediente = form.dateExpediente || null
  payload.numEmisor = form.numEmisor || null
  payload.dateEmisor = form.dateEmisor || null
  payload.codAsignacion = form.codAsignacion || null
  payload.dateReceptor = form.dateReceptor || null
  payload.dir3 = form.dir3 || null
  payload.numContrato = form.numContrato || null
  payload.codDepReceptor = form.codDepReceptor || null
  payload.cuotaSuplido = form.cuotaSuplido || null
  payload.periodoDesde = form.periodoDesde || null
  payload.periodoHasta = form.periodoHasta || null
  //   payload.tipoAsociado = form.tipoAsociado || null // TODO -> ¿Qué es?
  //   payload.fechaAplicacion = form.fechaAplicacion || null // TODO -> ¿Qué es?
  payload.idPlantilla = (overrideTemplate || form.template)?.idPlantilla || null

  if (form.issuer) {
    const formIssuer = form.issuer
    const issuer = new Issuer()
    issuer.Direccion = formIssuer.Direccion || null
    issuer.Poblacion = formIssuer.Poblacion || null
    issuer.CodigoPostal = formIssuer.CodigoPostal || null
    issuer.Provincia = formIssuer.Provincia || null
    issuer.CodigoPais = formIssuer.CodigoPais || null
    issuer.Telefono = formIssuer.Telefono || null
    issuer.EmailTecnico = formIssuer.EmailTecnico || null
    issuer.certAsociado = formIssuer.certAsociado || null
    issuer.RazonSocial = formIssuer.RazonSocial || null
    issuer.PersonaFisicaNombre = formIssuer.PersonaFisicaNombre || null
    issuer.PersonaFisicaPrimerApellido = formIssuer.PersonaFisicaPrimerApellido || null
    issuer.PersonaFisicaSegundoApellido = formIssuer.PersonaFisicaSegundoApellido || null
    issuer.CIF = formIssuer.CIF || null
    issuer.PersonaFisica = formIssuer.PersonaFisica ? PersonType.FISICA : PersonType.JURIDICA
    issuer.TipoResidencia = formIssuer.TipoResidencia || ResidenceType.RESIDENTE   
    payload.issuer = issuer
  }

  if (form.receiver) {
    const formReceiver = form.receiver
    const receiver = new Receiver()

    receiver.IdSociedad = formReceiver.IdSociedad
    receiver.IdSede = formReceiver.IdSede
    receiver.SendType = formReceiver.SendType || null
    receiver.LocationName = formReceiver.LocationName || null

    if (formReceiver.Address) {
      const receiverAddress = formReceiver.Address
      const address = new Address()
      address.AddressLine = receiverAddress.Address || null
      address.PostCode = receiverAddress.PostCode || null
      address.Town = receiverAddress.Town || null
      address.Province = receiverAddress.Province || null
      address.CountryCode = receiverAddress.CountryCode || null
      receiver.Address = address
    }

    if (formReceiver.Sociedad) {
      const formSociedad = formReceiver.Sociedad
      const sociedad = new Sociedad()
      sociedad.AgendaGeneral = !!formSociedad.AgendaGeneral
      sociedad.IsSeflInvoiceSociety = !!formSociedad.IsSeflInvoiceSociety
      sociedad.TIN = formSociedad.TIN || null
      sociedad.ResidenceType = formSociedad.ResidenceType || 'R'
      sociedad.PersonType = formSociedad.PersonType || 'J'
      sociedad.NameCorporateName = formSociedad.NameCorporateName || null
      sociedad.FirstSurname = formSociedad.FirstSurname || null
      sociedad.SecondSurname = formSociedad.SecondSurname || null

      if (formSociedad.RegistrationData) {
        const formRegistrationData = formSociedad.RegistrationData
        const registrationData = new RegistrationData()
        registrationData.Book = formRegistrationData.Book || null
        registrationData.RegisterOfCompaniesLocation = formRegistrationData.RegisterOfCompaniesLocation || null
        registrationData.Sheet = formRegistrationData.Sheet || null
        registrationData.Folio = formRegistrationData.Folio || null
        registrationData.Section = formRegistrationData.Section || null
        registrationData.Volume = formRegistrationData.Volume || null
        registrationData.AdditionalData = formRegistrationData.AdditionalData || null
        sociedad.RegistrationData = registrationData
      }

      receiver.Sociedad = sociedad
    }

    if (formReceiver.ContactDetails) {
      const formContactDetails = formReceiver.ContactDetails
      const contactDetails = new ContactDetails()
      contactDetails.Telephone = formContactDetails.Telephone || null
      contactDetails.TeleFax = formContactDetails.TeleFax || null
      contactDetails.WebAddress = formContactDetails.WebAddress || null
      contactDetails.ElectronicMail = formContactDetails.ElectronicMail || null
      contactDetails.INETownCode = formContactDetails.INETownCode || null
      contactDetails.ContactPersons = formContactDetails.ContactPersons || null
      contactDetails.CnoCnae = formContactDetails.CnoCnae || null
      contactDetails.AdditionalDetails = formContactDetails.AdditionalDetails || null
      receiver.ContactDetails = contactDetails
    }

    if (formReceiver.CentrosAdministrativos?.length) {
      const formCentrosAdministrativos = formReceiver.CentrosAdministrativos
      receiver.AdminsitrativeCentres = receiver.AdminsitrativeCentres === null ? [] : receiver.AdminsitrativeCentres
      formCentrosAdministrativos.forEach(formCentroAdm => {
        const administrativeCenter = new AdminsitrativeCentre()
        administrativeCenter.CentreCode = formCentroAdm.CentreCode || null
        administrativeCenter.RoleCode = formCentroAdm.RoleCode || null
        administrativeCenter.Name = formCentroAdm.Name || null
        administrativeCenter.FirstSurname = formCentroAdm.FirstSurname || null
        administrativeCenter.SecondSurname = formCentroAdm.SecondSurname || null
        administrativeCenter.ContactDetails = formCentroAdm.ContactDetails || null
        administrativeCenter.PhysicalIGLN = formCentroAdm.PhysicalIGLN || null
        administrativeCenter.LogicalOperationalPoint = formCentroAdm.LogicalOperationalPoint || null
        administrativeCenter.CentreDescription = formCentroAdm.CentreDescription || null

        if (formCentroAdm.Address) {
          const admCenterAddress = formCentroAdm.Address
          const address = new Address()
          address.AddressLine = admCenterAddress.Address || null
          address.PostCode = admCenterAddress.PostCode || null
          address.Town = admCenterAddress.Town || null
          address.Province = admCenterAddress.Province || null
          address.CountryCode = admCenterAddress.CountryCode || null
          administrativeCenter.Address = address
        }
        receiver.AdminsitrativeCentres.push(administrativeCenter)
      })
    }

    if (formReceiver.CentrosAdministrativosFB2B?.length) {
      const formCentrosAdministrativosFB2B = formReceiver.CentrosAdministrativosFB2B
      receiver.AdminsitrativeCentresFACeB2B = receiver.AdminsitrativeCentresFACeB2B === null ? [] : receiver.AdminsitrativeCentresFACeB2B
      formCentrosAdministrativosFB2B.forEach(formCentroAdmFB2B => {
        const administrativeCenterFB2B = new AdminsitrativeCentreFACeB2B()
        administrativeCenterFB2B.Code = formCentroAdmFB2B.Code || null
        administrativeCenterFB2B.Name = formCentroAdmFB2B.Name || null
        administrativeCenterFB2B.Role = formCentroAdmFB2B.Role || null
        receiver.AdminsitrativeCentresFACeB2B.push(administrativeCenterFB2B)
      })
    }

    if (formReceiver.FACeB2BIdentificatives) {
      const formIdentificatives = formReceiver.FACeB2BIdentificatives
      const identificatives = new FACeB2BIdentificatives()
      identificatives.DIRE = formIdentificatives.DIRE || null
      identificatives.Name = formIdentificatives.Name || null
      receiver.FACeB2BIdentificatives = identificatives
    }
    payload.receiver = receiver
  }

  if (form.irpf) {
    const formIrpf = form.irpf
    const taxWithHeld = new TaxWithHeld()
    taxWithHeld.taxType = formIrpf.TaxType || '04'
    taxWithHeld.taxRate = getNullableNumber(formIrpf.TaxRate)
    payload.taxesWithHeld = taxWithHeld
  }

  if (form.invoiceLines?.length) {
    const formLines = form.invoiceLines
    payload.invoiceLines = []
    formLines.forEach(invoiceLine => {
      const line = new InvoiceLine()
      line.codProducto = invoiceLine.codProducto || null
      line.descripcion = invoiceLine.descripcion || null
      line.precioUnitario = getNullableNumber(invoiceLine.precioUnitario)
      line.cantidad = getNullableNumber(invoiceLine.cantidad)
      line.subtotal = getNullableNumber(invoiceLine.subtotal)
      line.total = getNullableNumber(invoiceLine.total)
      line.UnitOfMeasure = getNullableNumber(invoiceLine.UnitOfMeasure)
      line.totalConImpuesto = getNullableNumber(invoiceLine.totalConImpuesto)
      line.lineNumber = getNullableNumber(invoiceLine.lineNumber)
      if (invoiceLine.descuentos?.length) {
        const formDescuento = invoiceLine.descuentos[0]
        const descuento = new Descuento()
        descuento.descuento = (formDescuento.incluyeDescuento ? formDescuento.descuento : null) || null
        descuento.cuota = (formDescuento.incluyeDescuento ? null : formDescuento.cuota) || null
        if (formDescuento.incluyeDescuento ? (descuento.descuento || descuento.descuento === 0) : (descuento.cuota || descuento.cuota === 0)) {
          line.descuentos = descuento
        }
      }
      if (invoiceLine.taxes?.length) {
        const formTaxes = invoiceLine.taxes
        line.taxes = []
        formTaxes.forEach(lineTax => {
          const tax = new Tax()
          tax.taxType = lineTax.TaxType || null
          tax.taxRate = getNullableNumber(lineTax.TaxRate)
          tax.cuota = getNullableNumber(lineTax.cuota)
          line.taxes.push(tax)
        })
      }
      line.AdditionalLineItemInformation = invoiceLine.additionalLineItemInformation || null
      payload.invoiceLines.push(line)
    })
  }

  if (form.paymentMethod) {
    const formPaymentMethod = form.paymentMethod
    const paymentMethod = new PaymentMethod()
    paymentMethod.formaPago = formPaymentMethod.formaPago || null
    paymentMethod.iban = formPaymentMethod.iban || null
    paymentMethod.bicSwift = formPaymentMethod.bicSwift || null
    paymentMethod.fechaMandato = formPaymentMethod.fecha || null
    paymentMethod.toBeCredit = !!formPaymentMethod.toBeCredit
    payload.paymentMethod = paymentMethod
  }

  if (includeFiles) {
    const checkFile = form.file?.[0] ?? form.file
    if (checkFile && !Array.isArray(checkFile)) {
      payload.file = await convertFileToBase64(checkFile)
    }
    if (form.Adjuntos?.length) {
      payload.Adjuntos = await Promise.all(form.Adjuntos.map(file => convertFileToBase64(file)))
    }
  }
  return payload
}

export default getPayloadFacturae
